import { DateTime } from '@ksyos/date-time';
import { Spacer } from '@ksyos/design-system';
import type { IOsasvcQuestionnaire } from './OsasvcV2RequestAddEdit';
import { OsasQuestionnaireName } from '../../../../../../../common/enums/osasQuestionnaireName';
import { FormLabel } from '../../../../../elements/forms/FormLabel';
import { HorizontalFormGroup } from '../../../../../elements/forms/HorizontalFormGroup';
import { OsasQuestionnaireScoreIndicator } from '../../../utils/v1/questionnaires/OsasQuestionnaireScoreIndicator';

export function OsasvcV2QuestionnairesScoresRead(props: { questionnaires: IOsasvcQuestionnaire[] }) {
    if (!props.questionnaires || props.questionnaires.length === 0) {
        return null;
    }

    const essQuestionnaires = props.questionnaires
        .filter((questionnaire) => questionnaire.name === OsasQuestionnaireName.ess)
        .sort((questionnaire1, questionnaire2) => (questionnaire2.dateSent < questionnaire1.dateSent ? 1 : -1))
        .map((questionnaire) => (
            <div style={{ marginRight: '16px' }}>
                <p className="mb-8">{DateTime.from(questionnaire.dateSent).format('DD-MM-YYYY')}</p>
                <OsasQuestionnaireScoreIndicator
                    onlyBadge
                    osasQuestionnaireScoreType={OsasQuestionnaireName.ess}
                    score={questionnaire.score}
                />
            </div>
        ));
    const fosq10Questionnaires = props.questionnaires
        .filter((questionnaire) => questionnaire.name === OsasQuestionnaireName.fosq10)
        .sort((questionnaire1, questionnaire2) => (questionnaire2.dateSent < questionnaire1.dateSent ? 1 : -1))
        .map((questionnaire) => (
            <div style={{ marginRight: '16px' }}>
                <p className="mb-8">{DateTime.from(questionnaire.dateSent).format('DD-MM-YYYY')}</p>
                <OsasQuestionnaireScoreIndicator
                    onlyBadge
                    osasQuestionnaireScoreType={'fosq10'}
                    score={questionnaire.score}
                />
            </div>
        ));

    return (
        <HorizontalFormGroup>
            <FormLabel>Uitkomst vragenlijsten</FormLabel>
            <Spacer>
                {fosq10Questionnaires.length > 0 && (
                    <Spacer direction="horizontal">
                        <div
                            className="d-flex h-100"
                            style={{ minWidth: '140px' }}
                        >
                            <p className="align-self-end mb-0 ml-80 font-weight-bold">FOSQ10</p>
                        </div>
                        {fosq10Questionnaires}
                    </Spacer>
                )}
                {essQuestionnaires.length > 0 && (
                    <Spacer direction="horizontal">
                        <div
                            className="d-flex h-100"
                            style={{ minWidth: '140px' }}
                        >
                            <p className="align-self-end mb-0 ml-80 font-weight-bold">ESS</p>
                        </div>
                        {essQuestionnaires}
                    </Spacer>
                )}
            </Spacer>
        </HorizontalFormGroup>
    );
}
